import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { trainer } from '../../../../model/trainer';
import { TrainerItem } from './TrainerItem';

interface IProps extends StyledComponentProps {
    trainerList: Array<trainer>;
    onTrainerClick: (sub: string) => void;
    selected: string;
}

export const TrainerList = (props: IProps) => {
    const classes = props.classes;
    return (
    <List className={classes.root}>
        {props.trainerList && props.trainerList.map(c =>
            <TrainerItem
                classes={classes}
                isSelected={props.selected === c._id}
                trainer={c}
                onTrainerClick={props.onTrainerClick}
                key={c._id}
            />)}
    </List>)
};